import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import app from '../services/AppService';
import { app_thunks } from '../constants/app';

const initialState = {
  config: null,
  loading: false,
  error: null,
};

export const getAppConfig = createAsyncThunk(
  app_thunks.APP_GET_CONFIG,
  async (data, { rejectWithValue }) => {
    try {
      const response = await app.getAppConfig();
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {},
  extraReducers: {
    [getAppConfig.pending]: (state) => {
      state.loading = true;
    },
    [getAppConfig.fulfilled]: (state, action) => {
      state.config = action.payload.data;
      state.loading = false;
    },
    [getAppConfig.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export default appSlice;
